import { TriangleAlert } from 'lucide-react';
import type { DisciplineWithCourses } from '@/lib/types';

interface ConfirmationWarningProps {
	discipline: DisciplineWithCourses;
}

export const ConfirmationWarning = ({ discipline }: ConfirmationWarningProps) => {
	const count = discipline?.courses_disciplines?.length;
	const courseIsAre = count === 1 ? 'is' : 'are';
	const coursePluralSingular = count === 1 ? 'course' : 'courses';
	const courseThisThese = count === 1 ? 'this course' : 'these courses';

	return (
		<>
			<p className="text-base py-4 text-primary">
				There {courseIsAre} currently <strong>{count}</strong> {coursePluralSingular} associated
				with this discipline. Please select another discipline for {courseThisThese}. Once selected,
				click <strong>Yes</strong>.
			</p>
			<div className="flex items-center gap-2 bg-yellow-400 text-body-text rounded-md p-2 mb-4">
				<TriangleAlert className="w-5 h-5 shrink-0 mr-2" />
				<span>
					Deleting a discipline impacts course alignment. Review course alignment to make any needed
					changes.
				</span>
			</div>
		</>
	);
};
